import { XCircle } from "react-feather";
import ellipseGreenIcon from "../../assets/images/ellipse-green.svg";
import { Button, Modal } from "../../components";
import useLanguage from "../../hooks/language";
import Appointment from "../../models/appointment";
import { getLocalizedAppointmentDateDetails } from "../../utils/appointment-display";
import styles from "./already-booked-screening.module.css";

export default function AlreadyBookedScreeningModal({
    appointment,
    screeningLabel,
    visible,
    onClose,
    onViewAppointment,
}: {
    appointment: Appointment | undefined;
    screeningLabel: string;
    visible: boolean;
    onClose: () => void;
    onViewAppointment: () => void;
}): React.ReactElement {
    const { translations, language } = useLanguage();
    const t = translations.homePage.bookedScreeningPopup;

    const closeModal = () => {
        if (!visible) {
            return;
        }
        onClose();
    };

    const appointmentDateDetails = appointment
        ? getLocalizedAppointmentDateDetails(appointment.datetime, language)
        : null;

    const body =
        appointment &&
        appointmentDateDetails &&
        appointment.clinic?.name &&
        t.body(
            screeningLabel,
            appointmentDateDetails.date,
            appointmentDateDetails.time,
            appointment.clinic.name
        );

    return (
        <Modal
            showHeader={false}
            visible={visible}
            onVisibilityChange={(isVisible) => {
                if (!isVisible) {
                    closeModal();
                }
            }}
            className={styles["already-booked-screening-modal"]}
        >
            <div className={styles["already-booked-screening-modal__close"]}>
                <button
                    className={
                        styles["already-booked-screening-modal__close-button"]
                    }
                    aria-label={translations.common.close}
                    onClick={closeModal}
                >
                    <XCircle aria-hidden="true" focusable="false" />
                </button>
            </div>

            <div className={styles["already-booked-screening-modal__content"]}>
                <img
                    src={ellipseGreenIcon}
                    alt=""
                    className={styles["already-booked-screening-modal__dot"]}
                />

                <h2 className={styles["already-booked-screening-modal__title"]}>
                    {t.title}
                </h2>

                {body && (
                    <p
                        className={
                            styles["already-booked-screening-modal__body"]
                        }
                    >
                        {body}
                    </p>
                )}

                <Button
                    type="primary"
                    className={styles["already-booked-screening-modal__cta"]}
                    onClick={onViewAppointment}
                >
                    {t.cta}
                </Button>
            </div>
        </Modal>
    );
}
